Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useSharedLang: true,
  useSharedStyles: true
};
Object.defineProperty(exports, "useSharedLang", {
  enumerable: true,
  get: function get() {
    return _useLang.useSharedLang;
  }
});
Object.defineProperty(exports, "useSharedStyles", {
  enumerable: true,
  get: function get() {
    return _sharedStyles.useSharedStyles;
  }
});
var _useLang = require("./useLang");
var _sharedStyles = require("./sharedStyles");
var _Layout = require("./Layout");
Object.keys(_Layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Layout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Layout[key];
    }
  });
});
var _IllustrationBackground = require("./IllustrationBackground");
Object.keys(_IllustrationBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _IllustrationBackground[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _IllustrationBackground[key];
    }
  });
});
var _Shapes = require("./Shapes");
Object.keys(_Shapes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Shapes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Shapes[key];
    }
  });
});
var _NextButton = require("./NextButton");
Object.keys(_NextButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NextButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NextButton[key];
    }
  });
});
var _Heading = require("./Heading");
Object.keys(_Heading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Heading[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Heading[key];
    }
  });
});
var _Column = require("../../../../components/Column");
Object.keys(_Column).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Column[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Column[key];
    }
  });
});
var _ColumnContainer = require("./ColumnContainer");
Object.keys(_ColumnContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ColumnContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ColumnContainer[key];
    }
  });
});